import { AxiosResponse } from 'axios';
import { INVENTORY_SERVICE_URL } from '../../../../config';
import { PaginatedInvoices } from '../../../../interfaces/invoices/paginatedStore.type';
import inventoryAxios from '../../../../utils/axios/inventory.axios';

const tryToFetchInvoices = (
    pageNumber: number,
    pageSize: number,
    data?: any,
): Promise<AxiosResponse<PaginatedInvoices>> => {
    const url = `${INVENTORY_SERVICE_URL}/hotel-purchase-orders-invoices/all?page=${pageNumber}&size=${pageSize}`;
    return inventoryAxios.put<PaginatedInvoices>(url, data)
}

const tryToEditInvoice = (id: string, data: any): Promise<AxiosResponse> => {
    return inventoryAxios.put(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders-invoices/${id}`, data);
};

const tryToFetchSingleInvoice = (id: string): Promise<AxiosResponse> => {
    return inventoryAxios.get(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders-invoices/${id}`)
};

const tryToSendEmailInvoice = (id: string): Promise<AxiosResponse> => {
    return inventoryAxios.put(`${INVENTORY_SERVICE_URL}/hotel-purchase-orders-invoices/${id}/send`);
};

export const InvoicesService = {
    tryToFetchInvoices,
    tryToEditInvoice,
    tryToFetchSingleInvoice,
    tryToSendEmailInvoice,
}